<template>
  <div v-if="show">
    <div class="main">
      <div class="swiper-container-com">
        <div class="swiper-wrapper">
          <template v-for="(item,i) in img">
            <div class="swiper-slide" :key="i" v-if="item.u"><img :src="item.u"/></div>
          </template>
        </div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
      <div class="close" @click="close"></div>
    </div>
    <div class="bg" @click="close"></div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import swiper from "swiper"
export default defineComponent({
  props: {
    img: {
      type: Array
    },
    index: {
      type: String
    }
  },
  data(){
    return {
      swiper:{},
      show: true
    }
  },
  mounted(){
    this.swiper = new swiper ('.swiper-container-com',{
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
    (this.swiper as any).slideTo(this.index, 0)
  },
  unmounted() {
    (this.swiper as any).destroy();
  },
  methods: {
    close(){
      this.$emit("close")
    }
  }
})
</script>
<style lang="less" scoped>
.main {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  z-index: 3;
  .close{
    position: absolute;
    width: 38px;
    height: 38px;
    right: -19px;
    top: -19px;
    cursor: pointer;
    z-index: 4;
    background-image: url("https://static.soyoung.com/sy-pre/lark20201225-171617-1608887400685.png");
    background-size: cover;
    &:hover{
      background-image: url("https://static.soyoung.com/sy-pre/lark20201225-171612-1608887400685.png");
    }
  }
}
.swiper-container-com{
  width: 600px;
  height: 400px;
  overflow: hidden;
  .swiper-slide{
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
      max-width: 100%;
      max-height: 100%;
      object-fit: cover;
    }
  }
  .swiper-button-prev{
    width: 40px;
    height: 40px;
    background-image :url("https://static.soyoung.com/sy-pre/17u0o1uqfic8w-1609733400695.png");
    background-size: cover;
    left:-40px;
    &:after{
      display: none;
    }
    &:hover{
      background-image :url("https://static.soyoung.com/sy-pre/3r50l73e34kwl-1609733400695.png");
    }
  }
  .swiper-button-next{
    width: 40px;
    height: 40px;
    background-image :url("https://static.soyoung.com/sy-pre/2uvwqo6mijrp-1609733400695.png");
    background-size: cover;
    right:-40px;
    &:after{
      display: none;
    }
    &:hover{
      background-image :url("https://static.soyoung.com/sy-pre/2qb1vuoij0rjs-1609733400695.png");
    }
  }
} 
.bg {
  background: #000;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  opacity: 0.5;
}
</style>